import { KeyValuePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoAttachments, DemoFieldsWithAttachment } from '@demo/data/demo-cipo-fields';
import { AttachmentModel } from '@models/module/fields/main';
import { CipoAttachmentComponent } from '@shared/components/fields/cipo-attachment/cipo-attachment.component';
import { CipoAttachmentConfig, CipoAttachmentControl } from '@shared/components/fields/common';

@Component({
  selector: 'app-demo-cipo-attachment',
  imports: [CipoAttachmentComponent, KeyValuePipe, FlexLayoutModule],
  templateUrl: './demo-cipo-attachment.component.html',
})
export class DemoCipoAttachmentComponent {
  fb = inject(FormBuilder);
  form = signal(this.fb.group<{ [x: string]: CipoAttachmentControl }>({}));
  basicAttachment = signal<AttachmentModel[]>([]);
  readonlyConfig = signal<CipoAttachmentConfig>({ readonly: true });

  constructor() {
    DemoFieldsWithAttachment.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoAttachmentControl(defaultValue, props);
      this.form().addControl(field.name, control);
    });

    this.basicAttachment.set(DemoAttachments);
  }
}
